import { createContext } from 'react'

export const AccessTokenContext = createContext({
    accessToken: null,
})

export default AccessTokenContext
